import classNames from 'classnames'
import AddressDropDown from 'components/Address/AddressDropDown'
import DeliveryDateDropdown from 'components/DeliveryDateDropdown'
import debounce from 'lodash/debounce'
import { DesktopNotification } from 'notification'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import './style.scss'

class SubHeader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            sticky: this.props.sticky,
        }
        this.updateStickyness = debounce(this.updateStickyness, 100)
    }

    componentWillUnmount() {
        this.unmounted = true
    }

    updateStickyness(sticky) {
        this.unmounted || this.setState({ sticky: sticky })
    }

    componentWillReceiveProps(nextProps) {
        this.updateStickyness(nextProps.sticky)
    }

    render() {
        const { sticky } = this.state
        const classes = classNames({
            'sub-header': true,
            'sub-header--sticky': sticky,
        })
        return (
            <div className={classes}>
                <DesktopNotification isInSubHeader={true} />
                <div className="delivery-options">
                    <AddressDropDown />
                    <DeliveryDateDropdown />
                </div>
            </div>
        )
    }
}

SubHeader.propTypes = {
    sticky: PropTypes.bool,
}

const mapStateToProps = ({ ui }) => {
    return {
        sticky: ui.showCart || ui.showDeliveryDatesDropdown || ui.showAddressDropdown,
    }
}

export default connect(mapStateToProps)(SubHeader)
